
import React from "react";
import { User } from "lucide-react";
import { Client } from "@/components/programs/ClientSelection";

interface ClientInformationSectionProps {
  selectedClient: Client | null;
}

export default function ClientInformationSection({ selectedClient }: ClientInformationSectionProps) {
  if (!selectedClient) return null;
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white/90 flex items-center gap-2 border-b border-white/20 pb-2">
        <User className="h-5 w-5" />
        Client Information
      </h3>
      
      <div className="space-y-3">
        <div className="flex">
          <span className="text-white/80 w-40">Name:</span>
          <span className="text-white">{selectedClient.name}</span>
        </div>
        {selectedClient.email && (
          <div className="flex">
            <span className="text-white/80 w-40">Email:</span>
            <span className="text-white">{selectedClient.email}</span>
          </div>
        )}
        {selectedClient.phone && (
          <div className="flex">
            <span className="text-white/80 w-40">Phone:</span>
            <span className="text-white">{selectedClient.phone}</span>
          </div>
        )}
        {selectedClient.age && (
          <div className="flex">
            <span className="text-white/80 w-40">Age:</span>
            <span className="text-white">{selectedClient.age}</span>
          </div>
        )}
        {selectedClient.gender && (
          <div className="flex">
            <span className="text-white/80 w-40">Gender:</span>
            <span className="text-white">{selectedClient.gender}</span>
          </div>
        )}
        {selectedClient.goals && (
          <div className="flex">
            <span className="text-white/80 w-40">Goals:</span>
            <span className="text-white">{selectedClient.goals}</span>
          </div>
        )}
      </div>
    </div>
  );
}
